module.exports = __webpack_public_path__ + "media/dashboard/assets/images/hero/instagram-third-step-fa6f197ca05d75d56a87b82e3605136b.png";